import { Box, Tooltip, Typography } from "@mui/material";

import { getGrowthStageExplanations, getGrowthStages } from "./WeatherHelper";

// Custom Growth Stage Progress Component
export const GrowthStageProgress = ({ cropType, currentStageData }) => {
  const stages = getGrowthStages(cropType);
  const explanations = getGrowthStageExplanations(cropType);
  const { index, progress } = currentStageData;

  // Alternate labels between top and bottom if there are more than 5 stages
  const shouldAlternateLabels = stages.length > 5;

  return (
    <Box className="growth-stage-container">
      {/* Top labels (for alternating layout) */}
      {shouldAlternateLabels && (
        <Box className="growth-stage-labels growth-stage-labels-top">
          {stages.map((stageName, stageIdx) => (
            <Tooltip key={`top-${stageIdx}`} title={explanations[stageIdx] || stageName} arrow placement="top">
              <Typography
                className={`growth-stage-label ${stageIdx <= index ? "growth-stage-label-active" : "growth-stage-label-inactive"} ${stageIdx % 2 === 0 ? "growth-stage-label-visible" : "growth-stage-label-hidden"}`}
              >
                {stageName}
              </Typography>
            </Tooltip>
          ))}
        </Box>
      )}

      {/* Single row labels (for normal layout) */}
      {!shouldAlternateLabels && (
        <Box className="growth-stage-labels growth-stage-labels-single">
          {stages.map((stageName, stageIdx) => (
            <Tooltip key={stageIdx} title={explanations[stageIdx] || stageName} arrow placement="top">
              <Typography
                className={`growth-stage-label ${stageIdx <= index ? "growth-stage-label-active" : "growth-stage-label-inactive"}`}
              >
                {stageName}
              </Typography>
            </Tooltip>
          ))}
        </Box>
      )}

      {/* Progress bar */}
      <Box className="growth-stage-progress-bar">
        <Box className="growth-stage-progress-fill" style={{ width: `${progress * 100}%` }} />
        {stages.map((_, idx) => (
          <Box
            key={idx}
            className={`growth-stage-marker ${idx <= index ? "growth-stage-marker-active" : "growth-stage-marker-inactive"}`}
            style={{ left: `${(idx / (stages.length - 1)) * 100}%` }}
          />
        ))}
      </Box>

      {/* Bottom labels (for alternating layout) */}
      {shouldAlternateLabels && (
        <Box className="growth-stage-labels growth-stage-labels-bottom">
          {stages.map((stageName, stageIdx) => (
            <Tooltip key={`bottom-${stageIdx}`} title={explanations[stageIdx] || stageName} arrow placement="bottom">
              <Typography
                className={`growth-stage-label ${stageIdx <= index ? "growth-stage-label-active" : "growth-stage-label-inactive"} ${stageIdx % 2 === 1 ? "growth-stage-label-visible" : "growth-stage-label-hidden"}`}
              >
                {stageName}
              </Typography>
            </Tooltip>
          ))}
        </Box>
      )}
    </Box>
  );
};
